export const callDirectionSelector = (state) => state.phoneStore.callDirection;
export const phoneFieldValueSelector = (state) =>
  state.phoneStore.phoneFieldValue;
export const subscriberSelector = (state) => state.phoneStore.subscriber;
export const isControlPanelVisibleSelector = (state) =>
  state.phoneStore.isControlPanelVisible;
export const numPadVisibleSelector = (state) => state.phoneStore.numPadVisible;
export const phoneFieldPosSelector = (state) => state.phoneStore.phoneFieldPos;
export const silentModeSelector = (state) => state.phoneStore.silentMode;
export const ringtonePlayErrorSelector = (state) =>
  state.phoneStore.ringtonePlayError;
export const ringtoneDevicesDataSelector = (state) =>
  state.phoneStore.ringtoneDevicesData;
export const selectedRingtoneDeviceSelector = (state) =>
  state.phoneStore.selectedRingtoneDevice;
export const userMediaErrorSelector = (state) =>
  state.phoneStore.userMediaError;
export const newRequestModalVisibleSelector = (state) =>
  state.newRequestStore.newRequestModalVisible;
export const serviceCompanyValueSelector = (state) =>
  state.phoneStore.serviceCompany;
export const companyVisibleValueSelector = (state) =>
  state.phoneStore.companyVisible;
